import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Rola até o elemento do hash (#secao) ao abrir a rota ou mudar o hash */
export function useHashScroll() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const id = decodeURIComponent(hash.replace(/^#/, ''));
    const t = window.setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 80);
    return () => window.clearTimeout(t);
  }, [hash]);
}
